/** @format */

import React from 'react';

const QuoterContextDefault = {
    isSaving: false, // used so we know when background saves are happening
    error: false, // an error occurred when saving the data
    cart: {},
    size: {}, // TODO! - currently handled in the order object
    order: {},
    designs_orders: [],
    uploads: [], // uploads are custom die and variable data. There should only be one of each
    pantones: [], // TODO!
    handleUpdate: () => {},
    hanndleChange: () => {}, // Alias to handleUpdate
    handleToggleOrder: () => {}, // Go to another order
    modalKey: false, // For help windows toggle
    handleToggleModal: () => {},
    handleIsComplete: () => {},
    handleDebounceQuoteUpdate: () => {}, // Update the overall quote
    handleMapOrderToState: () => {},
    handleMapCartToState: () => {},
    handleAddOrder: () => {},
    handleUpdateRollQty: () => {},
    handleSaveToAccount: () => {},
    handleLogin: () => {},
    showAllCornerOptions: true, // No preference for square corners
    quotedTotal: 0,
    // Mostly static information
    substrates: [],
    laminates: [],
    formFactors: [],
    processingTimes: [],
    shapes: [],
    showOrder: true,
    isAddingNewOrder: false,
    designQuoterStep: null,
    isLoggedIn: false
};
export default React.createContext(QuoterContextDefault);

export {QuoterContextDefault};
